import { auth, storage, db, serverTimestamp } from '../lib/firebase/firebase.js';
import { requiredFieldValidator, alphabetTextWithSpaceValidator, phoneNumberValidator, validate, emailValidator, passwordValidator, pngValidator, urlOptionalValidator, pinValidator } from '../lib/validator.js';
import { authorizedRouteStudent } from '../lib/auth.js';
import Swal from 'sweetalert2';
import {capitalizeFirstLetter} from '../lib/utils';



let loginForm = document.getElementById("login");

loginForm.addEventListener("submit", async (e) => {
    e.preventDefault();

    let loginButton = document.getElementById("login-button");
    loginButton.textContent = "Signing in...";
    loginButton.disabled = true;

    let email = document.getElementById("email");
    let password = document.getElementById("password");

    let formElements = [
        {
            field: email,
            validator: emailValidator,
            error_label: "email_error_label"
        },
        {
            field: password,
            validator: passwordValidator,
            error_label: "password_error_label"
        },

    ];


    if (validate(formElements)) {
        try {
            let user = await auth.signInWithEmailAndPassword(email.value.trim(), password.value.trim());

            let college = await db.collection("colleges").doc(user.user.uid).get();
            if (college.exists) {

                if (college.data().profile_updated == true && college.data().default_logo == false) {
                    await Swal.fire({
                        icon: 'success',
                        title: 'Logged In',
                        text: 'You will be redirected shortly',
                    });
                    sessionStorage.loggedIn = "true";
                    window.location.href = "profile.html";
                }
                else if (college.data().profile_updated != true) {
                    $('#profile_modal').modal('toggle');
                }
                else if (college.data().default_logo != false) {
                    $('#logoModal').modal('toggle');

                }


            }
            else {

                let data = {
                    "college_id": user.user.uid,
                    "college_name": null,
                    "college_description": null,
                    "phone_number": null,
                    "principal_phone_number": null,
                    "manager_phone_number": null,
                    "email": null,
                    "registered_email": email.value.trim(),
                    "website": null,
                    "logo":
                        "https://firebasestorage.googleapis.com/v0/b/kerala-colleges.appspot.com/o/college_logos%2Ftransparant_logo.png?alt=media&token=735ea015-7ac6-4676-912a-7b164cddb486",
                    "university_id": null,
                    "university": null,
                    "place": null,
                    "district": null,
                    "state": "kerala",
                    "post_office": null,
                    "pin": null,
                    "registered_on": serverTimestamp(),
                    "status": "active",
                    "verified": false,
                    "default_logo": true,
                    "profile_updated": false,
                    "courses": [],
                    "course_names": [],
                    "course_details": []
                };

                let result = await db.collection("colleges").doc(user.user.uid).set(data);

                $('#profile_modal').modal('toggle');


            }

            loginButton.textContent = "Sign In";
            loginButton.disabled = false;
        }
        catch (error) {

            try {
                let user = await auth.createUserWithEmailAndPassword(email.value.trim(), password.value.trim());




                let data = {
                    "college_id": user.user.uid,
                    "college_name": null,
                    "college_description": null,
                    "phone_number": null,
                    "principal_phone_number": null,
                    "manager_phone_number": null,
                    "email": null,
                    "registered_email": email.value.trim(),
                    "website": null,
                    "logo":
                        "https://firebasestorage.googleapis.com/v0/b/kerala-colleges.appspot.com/o/college_logos%2Ftransparant_logo.png?alt=media&token=735ea015-7ac6-4676-912a-7b164cddb486",
                    "university_id": null,
                    "university": null,
                    "place": null,
                    "district": null,
                    "state": "kerala",
                    "post_office": null,
                    "pin": null,
                    "registered_on": serverTimestamp(),
                    "status": "active",
                    "verified": false,
                    "default_logo": true,
                    "profile_updated": false,
                    "courses": [],
                    "course_names": [],
                    "course_details": []
                };

                let result = await db.collection("colleges").doc(user.user.uid).set(data);

                $('#profile_modal').modal('toggle');


            }
            catch(error){
                await Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'Password is incorrect!',
                });
                console.log(error.message);
    
            }

            console.log(error.message);
            

            loginButton.textContent = "Sign In";
            loginButton.disabled = false;

        }
    }



});

let districtSelect = document.getElementById("district");

db.collection("states").where("state", "==", "kerala").get().then((state) => {
    let districts = state.docs[0].data().districts;

    districts.forEach((district) => {
        let option = document.createElement("option");
        option.value = district;
        option.textContent = district;

        districtSelect.append(option);
    })

    let stateSelect = document.getElementById("state");
    let option = document.createElement("option");
    option.textContent = state.docs[0].data().state;
    option.value = state.docs[0].id;
    stateSelect.append(option);
})


let universitySelect = document.getElementById("university");

db.collection("universities").get().then((universities) => {

    universities.forEach((university) => {
        let option = document.createElement("option");
        option.value = university.id;
        option.textContent = capitalizeFirstLetter(university.data().university_name);

        universitySelect.append(option);
    })
})



let profileUpdateForm = document.getElementById("profile_form");

profileUpdateForm.addEventListener("submit", async (e) => {
    e.preventDefault();


    let submitButton = profileUpdateForm.querySelector("button");

    let collegeName = document.getElementById("college_name");
    let collegeDescription = document.getElementById("college_description");
    let email = document.getElementById("email");
    let phoneNumber = document.getElementById("phone_number");
    let principalPhoneNumber = document.getElementById("principal_phone_number");
    let managerPhoneNumber = document.getElementById("manager_phone_number");
    let website = document.getElementById("website");
    let university = document.getElementById("university");
    let state = document.getElementById("state");
    let district = document.getElementById("district");
    let place = document.getElementById("place");
    let postOffice = document.getElementById("post_office");
    let pin = document.getElementById("pin");

    let submitText = "Update";
    let submittingText = "Updating...";

    submitButton.textContent = submitText;


    let formElements = [
        {
            field: collegeName,
            validator: alphabetTextWithSpaceValidator,
            error_label: "college_name_error_label"
        },
        {
            field: collegeDescription,
            validator: requiredFieldValidator,
            error_label: "college_description_error_label"
        },
        {
            field: email,
            validator: emailValidator,
            error_label: "email_error_label"
        },
        {
            field: phoneNumber,
            validator: phoneNumberValidator,
            error_label: "phone_number_error_label"
        },
        {
            field: principalPhoneNumber,
            validator: phoneNumberValidator,
            error_label: "principal_phone_number_error_label"
        },
        {
            field: managerPhoneNumber,
            validator: phoneNumberValidator,
            error_label: "manager_phone_number_error_label"
        },
        {
            field: website,
            validator: urlOptionalValidator,
            error_label: "website_error_label"
        },

        {
            field: state,
            validator: requiredFieldValidator,
            error_label: "state_error_label"
        },
        {
            field: district,
            validator: requiredFieldValidator,
            error_label: "district_error_label"
        },
        {
            field: place,
            validator: alphabetTextWithSpaceValidator,
            error_label: "place_error_label"
        },

        {
            field: postOffice,
            validator: alphabetTextWithSpaceValidator,
            error_label: "post_office_error_label"
        },
        {
            field: pin,
            validator: pinValidator,
            error_label: "pin_error_label"
        },




    ];


    if (validate(formElements)) {

        submitButton.textContent = submittingText;
        submitButton.disabled = true;

        let collegeNameValue = collegeName.value.trim().toLowerCase();
        let collegeDescriptionValue = collegeDescription.value.trim().toLowerCase();
        let emailValue = email.value.trim().toLowerCase();
        let phoneNumberValue = phoneNumber.value.trim().toLowerCase();
        let websiteValue = website.value.trim().toLowerCase();

        let principalPhoneNumberValue = principalPhoneNumber.value.trim().toLowerCase();
        let manangerPhoneNumberValue = managerPhoneNumber.value.trim().toLowerCase();
        let universityIdValue = university.value;
        let stateValue = state.value;
        let districtValue = district.value;
        let placeValue = place.value.trim().toLowerCase();
        let postOfficeValue = postOffice.value.trim().toLowerCase();
        let pinValue = pin.value.trim().toLowerCase();

        let universityNameValue = (university.options[university.selectedIndex].text).toLowerCase();
        let stateNameValue = (state.options[state.selectedIndex].text).toLowerCase();

        try {

            let data = {
                college_name: collegeNameValue,
                college_description: collegeDescriptionValue,
                email: emailValue,
                phone_number: phoneNumberValue,
                principal_phone_number: principalPhoneNumberValue,
                manager_phone_number: manangerPhoneNumberValue,
                website: websiteValue,
                university: universityNameValue,
                university_id: universityIdValue,
                state_id: stateValue,
                state: stateNameValue,
                district: districtValue,
                place: placeValue,
                post_office: postOfficeValue,
                pin: pinValue,
                profile_updated: true
            };


            let user = auth.currentUser;

            if (user != null) {
                await db.collection("colleges").doc(user.uid).update(data);

                await Swal.fire({
                    icon: 'success',
                    title: 'Success',
                    text: 'Updated',
                });

                let college = await db.collection("colleges").doc(user.uid).get();

                if (college.data().default_logo == false) {
                    window.location.href = "profile.html";

                }
                else {
                    $('#profile_modal').modal('toggle');

                    $('#logoModal').modal('toggle');

                }

            }
            else {
                await Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'Something Went Wrong! Please Try Again!',
                });

            }

            submitButton.textContent = submitText;
            submitButton.disabled = false;

        }
        catch (error) {
            await Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'Something Went Wrong',
            });

            submitButton.textContent = submitText;
            submitButton.disabled = false;
            //TODO Delete Console Log
            console.log(error.message);
            $('#profile_modal').modal('toggle');


        }

    }
})


auth.onAuthStateChanged(async (user) => {
    let signInButton = document.getElementById("login-button");
    signInButton.hidden = false;

    if (user) {

        let college = await db.collection("colleges").doc(user.uid).get();

        if (college.exists) {
            signInButton.hidden = true;

            if (college.data().profile_updated == true && college.data().default_logo == false) {
                await Swal.fire({
                    icon: 'success',
                    title: 'Logged In',
                    text: 'You will be redirected shortly',
                });
                sessionStorage.loggedIn = "true";
                window.location.href = "profile.html";
            }
            else if (college.data().profile_updated != true) {
                $('#profile_modal').modal('toggle');
            }
            else if (college.data().default_logo != false) {
                $('#logoModal').modal('toggle');

            }
        }
        else {
            signInButton.hidden = false;
            // await auth.signOut();
        }
    }
})


let logoForm = document.getElementById("logo-form");

logoForm.addEventListener("submit", async (e) => {
    e.preventDefault();

    let submitText = "Set";
    let submittingText = "Setting...";

    let submitButton = document.getElementById("logo-submit-button");

    let logo = document.getElementById("logo");

    let formElements = [
        {
            field: logo,
            validator: pngValidator,
            error_label: "logo_error_label"
        }
    ];


    if (validate(formElements)) {


        let img;
        let height;
        let width;
        let logoErrorLabel = document.getElementById("logo_error_label_2");


        img = await loadImage(logo.files[0]);
        height = img.naturalHeight;
        width = img.naturalWidth;



        if (logoErrorLabel == null) {
            logoErrorLabel = document.createElement("span");
            logoErrorLabel.id = "logo_error_label_2";
            logoErrorLabel.classList.add("text-danger");
            logo.after(logoErrorLabel);

            logo.addEventListener("change", async (e) => {
                let img = await loadImage(logo.files[0]);
                let height = img.naturalHeight;
                let width = img.naturalWidth;

                if (height != 90 || width != 90) {

                    logoErrorLabel.textContent = "Invalid Dimensions! Only 90x90 Is Allowed"
                }
                else {
                    logoErrorLabel.textContent = "";
                }
            })
        }
        logoErrorLabel = document.getElementById("logo_error_label_2");

        if ((height != 90 || width != 90)) {

            logoErrorLabel.textContent = "Invalid Dimensions! Only 90x90 Is Allowed"
        }
        else {
            logoErrorLabel.textContent = "";
            submitButton.textContent = submittingText;
            submitButton.disabled = true;

            try {

                let imageRef = storage.ref();
                let user = auth.currentUser;

                if(user){
                    let id = user.uid;

                    let filename = id + ".png";
                    let logoRef = imageRef.child("college_logos/" + filename);
                    let logoFile = logo.files[0];
    
                    let uploaded = await logoRef.put(logoFile);
    
                    let url = await uploaded.ref.getDownloadURL();
                    let data = {};
                    data["logo"] = url;
                    data["default_logo"] = false;
    
                    await db.collection("colleges").doc(id).update(data);
    
                    await Swal.fire({
                        icon: 'success',
                        title: 'Success',
                        text: 'Logo Set',
                    });
                    window.location.href = "profile.html";

                }
                else{
                    await Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: 'Something Went Wrong! Please try again!',
                    });
                }
                

                submitButton.textContent = submitText;
                submitButton.disabled = false;
                let closeButton = e.target.parentNode.parentNode.querySelector(".close");
                closeButton.click();


            }
            catch (error) {
                await Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'Something Went Wrong',
                });

                submitButton.textContent = submitText;
                submitButton.disabled = false;
                //TODO Delete Console Log
                console.log(error.message);
                let closeButton = e.target.parentNode.parentNode.querySelector(".close");
                closeButton.click();
            }

        }

    }
});

function loadImage(file) {
    return new Promise((resolve, reject) => {
        let url = URL.createObjectURL(file);

        const img = new Image();
        img.addEventListener('load', () => {
            URL.revokeObjectURL(url);
            resolve(img)
        });
        img.addEventListener('error', reject); // don't forget this one
        img.src = url;
    });
}
